const labels = { BALANCE: '余额', XIAODUBI: '零售价', GIFT: '赠额（学费）' }

function rewardType(item) {
  const conditions = item.activityConditionListVOS || []
  return String(item.rewardType || (conditions[conditions.length - 1] || {}).rewardType || '').trim().toUpperCase()
}

export function isVirtualReward(item) {
  return Object.prototype.hasOwnProperty.call(labels, rewardType(item))
}

export function virtualRewardLabel(item) {
  return labels[rewardType(item)] || '虚拟赠品'
}

export function rewardAmountText(value) {
  if (value === null || value === undefined || value === '') return '待确认'
  const text = String(value).trim()
  return /^\d+(\.\d+)?$/.test(text) && Number(text) > 0 ? `${text}元` : '待确认'
}

export function hasVirtualRewardAmount(item) {
  return rewardAmountText(item.finalRewardValue) !== '待确认'
}
